import React from 'react';
import { useAuthenticator } from '@aws-amplify/ui-react';
import PaymentsData from '../section/PaymentsData.js';
import { Authenticator } from '@aws-amplify/ui-react';
import PortalPageLayout from '../components/PortalPageLayout.js';

export const PaymentsPage = () => {
  const { user } = useAuthenticator((context) => [context.user]);
    return (
      <PortalPageLayout user={user}>
        <Authenticator className='login_container container' loginMechanisms={['email']} hideSignUp>
          {user && (
            <PaymentsData/>
          )}
        </Authenticator>
      </PortalPageLayout>
    );
  }